//@flow
import { useEffect, useCallback } from 'react';
import { useStore } from '../store/useStore';
import { TypeAppVerReceived } from '../store/appVersion';
import Package from '../../package.json';
import compareVersions from 'compare-versions';

const POLLING_INTERVAL = 5 * 60 * 1000; // 5 minutes

export const useVersionCheck = () => {
    const { dispatch } = useStore();

    const checkVersion = useCallback(async () => {
        try {
            // Append timestamp to avoid caching
            const response = await fetch('/meta.json?t=' + new Date().getTime());
            if (!response.ok) return;
            const meta = await response.json();

            const compare = compareVersions(meta.version, Package.version);

            if (compare === 1) { // meta.version > Package.version
                dispatch({
                    type: TypeAppVerReceived,
                    appUpdate: true,
                    appVersion: meta.version,
                    appUpdateTitle: 'New Update Available',
                    appUpdateNotes: ['A new version of the application is available. Please update to ensure you have the latest features and fixes.']
                });
            }
        } catch (error) {
            console.error('Failed to check version:', error);
        }
    }, [dispatch]);

    useEffect(() => {
        // Check immediately
        checkVersion();

        // Set up polling
        const interval = setInterval(checkVersion, POLLING_INTERVAL);

        // Check on window focus
        const onFocus = () => {
            checkVersion();
        };

        window.addEventListener('focus', onFocus);

        return () => {
            clearInterval(interval);
            window.removeEventListener('focus', onFocus);
        };
    }, [checkVersion]);
};
